import React, { useContext } from 'react'
import { Title as ScreenTitle } from 'components'
import { UserContext } from './UserContext'
import { useParams } from 'react-router-dom'

const User = (props) => {
    const { isNewUser, setRoleAcordions, roleAcordions, grades, testTakers, roles, affiliations, userRoles, setUserRoles } = useContext(UserContext)
    const { affiliationID } = useParams()

    return (
        <ScreenTitle
            {...props}
            featureRoute={affiliationID && {
                path: `/affiliations/${affiliationID}`,
                state: {
                    tabIndex: 2
                }
            }}
            breadcrumbs={true}>
            <div className='bread-crumbs-title'>
                <div>{">"}</div>
                {isNewUser ? "הוספת משתמש חדש" : "עריכת משתמש"}
            </div>
        </ScreenTitle>
    )
}

export default User